export const productListPage = 'product-list'
export const maxProductDescriptionLength = 180
export const minProductInStockCount = 5